import { render, staticRenderFns } from "./flowProcess.vue?vue&type=template&id=64ea4d20&"
import script from "./flowProcess.vue?vue&type=script&lang=js&"
export * from "./flowProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/flow/flowProcess.vue"
export default component.exports